import { render, staticRenderFns } from "./Alibaba-received.vue?vue&type=template&id=000cb534&scoped=true&"
import script from "./Alibaba-received.vue?vue&type=script&lang=js&"
export * from "./Alibaba-received.vue?vue&type=script&lang=js&"
import style0 from "./Alibaba-received.vue?vue&type=style&index=0&id=000cb534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000cb534",
  null
  
)

export default component.exports